import { render, staticRenderFns } from "./LaudoRelatorioTerritorialModal.vue?vue&type=template&id=bdad1cae&scoped=true&lang=pug"
import script from "./LaudoRelatorioTerritorialModal.vue?vue&type=script&lang=js"
export * from "./LaudoRelatorioTerritorialModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoRelatorioTerritorialModal.vue?vue&type=style&index=0&id=bdad1cae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdad1cae",
  null
  
)

export default component.exports